module.exports = __webpack_public_path__ + "public/images/dome-tablet.dd65dab83495373a15f87a3d6398b2d3.svg";